import * as Yup from "yup";

const AddUserSchema = Yup.object().shape({
  name: Yup.string()
    .min(4, "Too short")
    .max(30, "Too long")
    .required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});

export default AddUserSchema;
